// extracted by mini-css-extract-plugin
module.exports = {"main-nav":"main-nav--2d8YC","navList":"navList--39o_n","nav":"nav--18Apz","selected":"selected--1WP9e"};